export const getHeaderCounterText = <T>(items: T[], selectedItems?: T[]) => {
  return selectedItems && selectedItems.length > 0
    ? `(${selectedItems.length}/${items.length})`
    : `(${items.length})`;
};

export const getFilterCounterText = (count) =>
  `${count} ${count === 1 ? "match" : "matches"}`;
